'use client';
import type { BlockType, ComputedVisibilityPayloadType } from '@unifyapps/defs/types/block';
import { useCallback } from 'react';
import { useEvaluateConditionalOperator } from '../useComputeConditionEvaluationGetter';

export const isTargetVisible = (visibility: ComputedVisibilityPayloadType | undefined) => {
  if (!visibility) return true;

  if (visibility.value === 'conditions') {
    return visibility.conditions !== false;
  }

  return visibility.value !== false;
};

function useIsBlockVisibility() {
  const { evaluateConditionalOperator } = useEvaluateConditionalOperator();

  const getIsBlockVisibility = useCallback(
    ({
      context = {},
      visible,
    }: {
      visible: BlockType['visibility'];
      context?: Record<string, unknown>;
    }) => {
      if (!visible) return true;

      if (visible.value === 'conditions') {
        const conditions = evaluateConditionalOperator({
          conditionEvaluationObj: visible.conditions,
          context,
        });

        return conditions !== false;
      }

      return visible.value !== false;
    },
    [evaluateConditionalOperator],
  );

  return { getIsBlockVisibility };
}

export default useIsBlockVisibility;
